/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyUserSerializer
 */
export interface ReadOnlyUserSerializer {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyUserSerializer
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUserSerializer
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUserSerializer
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUserSerializer
     */
    ssoId?: string | null;
}

export function ReadOnlyUserSerializerFromJSON(json: any): ReadOnlyUserSerializer {
    return ReadOnlyUserSerializerFromJSONTyped(json, false);
}

export function ReadOnlyUserSerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyUserSerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'surname': json['surname'],
        'ssoId': !exists(json, 'sso_id') ? undefined : json['sso_id'],
    };
}

export function ReadOnlyUserSerializerToJSON(value?: ReadOnlyUserSerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'surname': value.surname,
        'sso_id': value.ssoId,
    };
}


